import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { SchedulePartialStoreState } from '../schedule.reducer';
import { OnDemandTripsActions } from './ondemand-trips.action';
import * as OnDemandTripsSelector from './ondemand-trips.selectors';
import { OnDemandPublicTrip } from '@ridango/core';


@Injectable()
export class OnDemandTripsFacade {
    trips$: Observable<OnDemandPublicTrip[]> = this.store.select(OnDemandTripsSelector.getTrips);
    polyline$: Observable<string> = this.store.select(OnDemandTripsSelector.getPolylines);
    selectedTrip$: Observable<OnDemandPublicTrip> = this.store.select(OnDemandTripsSelector.getSelectedTrip);
    loading$: Observable<boolean> = this.store.select(OnDemandTripsSelector.getLoading);

    constructor(private store: NgRedux<SchedulePartialStoreState>, private actions: OnDemandTripsActions) {}

    fetchOndemandTrips(date) {
        this.store.dispatch(this.actions.fetchOnDemandTrips(date));
    }

    fetchUpcomingTrips() {
        this.store.dispatch(this.actions.fetchUpcomingTrips());
    }

    addPolyline(polyline: string) {
        this.store.dispatch(this.actions.addPolyline(polyline));
    }

    setSelectedTrip(trip: OnDemandPublicTrip) {
        this.store.dispatch(this.actions.setSelectedTrip(trip));
    }
}
